import { Box } from '@mantine/core';
import { Prism } from '@mantine/prism';
import type { ISecodaEntity } from '../../../api';

// DDLTab component for Semantic View definition
export function DllTab({ table }: { table: ISecodaEntity }) {
	const ddl = table?.properties2?.ddl;
	if (!ddl) {
		return (
			<Box p="md">
				<p>No definition available for this view.</p>
			</Box>
		);
	}
	return (
		<Box className="code-block">
			<Prism language="sql" withLineNumbers>
				{String(ddl)}
			</Prism>
		</Box>
	);
}
